'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTop = void 0;
const $ = require("jquery");
class PageTop {
    constructor() {
        $('.trigToTop').click(function () {
            $('body, html').animate({
                scrollTop: 0 //ページトップまでスクロール
            }, 500); //ページトップスクロールの速さ。数字が大きいほど遅くなる
            return false; //リンク自体の無効化
        });
    }
}
exports.PageTop = PageTop;
exports.default = PageTop;
